<template>
  <div>
      <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title" >Búsqueda por criterio: "{{this.searchCriterionProp}}"</v-toolbar-title>
    </v-toolbar>
    <v-content class="body-content">
      <div class="coincidences-container">
        <span class="mx-1">{{`Coincidencias encontradas: ${this.arrayCriterios.length}`}}</span>
      </div>
    </v-content>
    <v-content class="body-content-secondary">
      <ul class="ul-container">
        <SearchCriterioItemList
        v-for="criterio in this.arrayCriterios"
        :key="criterio.id"
        :criterio="criterio.nombre"
        :subarea="criterio.subarea"
        :area="criterio.area"
        :subareaId="criterio.subareaId"
        :areaIcon="criterio.areaIcon"
        ></SearchCriterioItemList>
      </ul>
    </v-content>
  </div>
</template>
<script>
import SearchCriterioItemList from '../components/SearchCriterioItemList.vue'
export default {

  props: {
    searchCriterionProp: String,
    arrayCriterios: []
  },
  components: {
    SearchCriterioItemList
  },
  mounted () {
    if (this.arrayCriterios === undefined) { this.$router.push({ name: 'dashboard' }) }
  }

}
</script>

<style scoped>
.toolbar-element {
  background: linear-gradient(#e2e2e2, #cbd1db);
}
.toolbar-title {
  font-size: 2.2em;
  font-family: SourceSansProLight, sans-serif;
  color: #293968;
}
.spacing-top {
  margin-top: 5.2em !important;
}

.body-content {
    padding: 0 !important;
    margin: 5.5em 0 0 0 !important;
}

.body-content-secondary {
    background-color: white;
    padding: 0 0 0 0 !important;
    margin-top: 10px;
    min-height: 38.5em;
}

.ul-container{
  padding-left: 0;
  padding-bottom: 5.5em;
}

.coincidences-container {
    font-size: 1.4em;
    font-family: SourceSansProRegular, sans-serif;
    color: #293968;
}

</style>
